<template>
  <span class="demo-badge" v-t="'demo.badge'" />
</template>

<script>
export default {
  name: 'demo-badge'
}
</script>

<style lang="scss" scoped>
.demo-badge {
  border-radius: 20px;
  padding: 8px 12px;
  text-transform: uppercase;
  background-color: $age-badge-purple-background;
  color: white;
  font: {
    size: 16px;
    weight: 900;
  }
}
</style>
